// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d24e91d","455":"8dc7eecd","977":"b7f72a83"}[chunkId] + ".chunk.js";
};